// ConfirmDialog.jsx
import React, { useCallback } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';

export function ConfirmDialog({
                                  open,
                                  title,
                                  content,
                                  onConfirm,
                                  onCancel,
                                  onClose,
                                  confirmText = 'Confirm',
                                  cancelText = 'Cancel',
                              }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleKeyDown = useCallback(
        (event) => {
            if (
                event.key === 'Enter' &&
                !event.shiftKey &&
                !event.ctrlKey &&
                !event.metaKey
            ) {
                event.preventDefault();
                onConfirm();
            }
        },
        [onConfirm]
    );

    return (
        <Dialog
            style={{ zIndex: 10000 }}
            open={open}
            onClose={onClose || onCancel}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
            fullWidth
            maxWidth="xs"
            PaperProps={{
                sx: {
                    width: isMobile ? '90%' : 'auto',
                    minWidth: isMobile ? '90%' : '400px',
                },
            }}
        >
            <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <Typography variant="body1" id="confirm-dialog-description" gutterBottom>
                    {content}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>
                    {cancelText}
                </Button>
                <Button
                    autoFocus
                    onClick={onConfirm}
                    color="primary"
                    variant="contained"
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}